import React from "react";
import { Lyrics, MusicNote, ViewHeadline } from "@mui/icons-material";
import { ToggleButton, ToggleButtonGroup, Tooltip } from "@mui/material";

export type SongContent = "tabs" | "chords" | "lyrics";

export interface SongContentTogglesProps {
  visibleContent: SongContent[];
  onVisibleContentChange: (content: SongContent[]) => void;
}

const contentOptions = [
  { value: "tabs", label: "Tabs", Icon: ViewHeadline },
  { value: "chords", label: "Chords", Icon: MusicNote },
  { value: "lyrics", label: "Lyrics", Icon: Lyrics },
] as const;

export const SongContentToggles: React.FC<SongContentTogglesProps> = ({
  visibleContent,
  onVisibleContentChange,
}) => (
  <ToggleButtonGroup
    value={visibleContent}
    onChange={(_event, content) => onVisibleContentChange(content)}
    size="small"
    aria-label="Visible song content"
    sx={{ height: { xs: 26, md: 30 }, flexShrink: 0 }}
  >
    {contentOptions.map(({ value, label, Icon }) => (
      <Tooltip key={value} title={`Toggle ${label.toLowerCase()}`}>
        <ToggleButton
          value={value}
          aria-label={label}
          sx={{
            px: 0.75,
            bgcolor: "#ffffff",
            "&.Mui-selected": { bgcolor: "#ffffff", color: "primary.main" },
            "&:hover, &.Mui-selected:hover": { bgcolor: "#eff6ff" },
          }}
        >
          <Icon fontSize="small" />
        </ToggleButton>
      </Tooltip>
    ))}
  </ToggleButtonGroup>
);
